import { MathUtils } from "../utils/MathUtils.js";
/**
 * modalità di display verticale o landscape
 */
 export enum DisplayMode {
    PORTRAIT = 0,
    LANDSCAPE = 1,
};

/**
 * rappresenta una proporzione d'aspetto
 */
export class AspectRatio {
    
    public readonly ratio: number
    public readonly displayMode: DisplayMode;
    

    constructor(public readonly wide: number, public readonly high: number) {
        const preRatio = wide / high;
        this.ratio = Math.round((preRatio + Number.EPSILON) * 100) / 100
    }

    /**
     * fornisce la proporzione inversa
     * @returns un nuovo oggetto con la proporzione inversa
     */
    public reverse(): AspectRatio {
        return new AspectRatio(this.high,this.wide);
    }

    /**
     * fornisce una proporzione assoluta
     * @returns 
     */
    public horizontal(): AspectRatio {
        if(this.isHorizontal()) return this;
        else return this.reverse();
    }


    public isVertical(): boolean {
        if(this.wide > this.high) return false;
        else return true;
    }

    public isHorizontal(): boolean {
        return !this.isVertical();
    }

    public vertical(): AspectRatio {
        if(this.isHorizontal()) return this.reverse();
        else return this;
    }

    public contains(other: AspectRatio): boolean {

        return this.ratio >= other.ratio;
    }

    public absoluteContains(other: AspectRatio): boolean {
        const a = this.horizontal();
        const b = other.horizontal();
        return a.ratio >= b.ratio;
    }


    public distance(other: AspectRatio): number {
        if(other.ratio > this.ratio) return other.ratio - this.ratio;
        else return this.ratio - other.ratio;
    }


    public toString(): string {
        return `${this.wide}:${this.high} (${this.ratio})`;
    }

    

};


export const AspectRatio_16_9 =  new AspectRatio(16,9);
export const AspectRatio_4_3 =   new AspectRatio(4,3);
export const AspectRatio_5_4 =   new AspectRatio(5,4);
export const AspectRatio_3_2 =   new AspectRatio(3,2);
export const AspectRatio_16_10 = new AspectRatio(16,10);

export const AspectRatio_1_1 = new AspectRatio(1,1);

export const AspectRatio_9_16 = AspectRatio_16_9.reverse();
export const AspectRatio_4_5 =  AspectRatio_5_4.reverse();
export const AspectRatio_3_4 =  AspectRatio_4_3.reverse();
export const AspectRatio_2_3 =  AspectRatio_3_2.reverse();
export const AspectRatio_10_16 = AspectRatio_16_10.reverse();


export const WellKnownRatios: AspectRatio[] = [AspectRatio_16_9, AspectRatio_4_3, AspectRatio_5_4, AspectRatio_3_2, AspectRatio_16_10, AspectRatio_1_1].map(e => e.horizontal());


export function calculateAspectRatio(width: number, height: number): AspectRatio  {
    const gcd = MathUtils.GCD(width,height);
    return new AspectRatio(width/gcd, height/gcd);
}


type RatioWithDistance = {
    distance: number,
    ratio: AspectRatio
}

export function approxToWellKnownRatio(r: AspectRatio, maxDistance: number = 0.1): AspectRatio {
    const abs = r.horizontal();
    const withDistance: RatioWithDistance[] = WellKnownRatios.map(ratio => {
        //console.log(`distance from ${ratio.wide} / ${ratio.high} is ${ratio.distance(abs)}`)
        return{
            distance: ratio.distance(abs),
            ratio: ratio
        } 
    }).filter(e => e.distance <= maxDistance).sort((a,b) => {
        return a.distance - b.distance;
    });
    //console.log("WIth Distance: ",withDistance);
    if(withDistance && withDistance.length > 0) {
        const newRatio = withDistance[0].ratio;
        //console.log("NewRatio: ",newRatio);       
        return r.isVertical()?newRatio.vertical():newRatio;
    }
    else return r;
     
}